'use strict';

if (!String.prototype.startsWith) {
  Object.defineProperty(String.prototype, 'startsWith', {
    enumerable: false,
    configurable: false,
    writable: false,
    value: function value(searchString, position) {
      position = position || 0;
      return this.lastIndexOf(searchString, position) === position;
    }
  });
}


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/plugins/string.startsWith.js
 **/